import { PlusIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { LexOfficeBookingDataLineItem } from '../../../types';

import BookingLineItemCard from './BookingLineItemCard';

interface BookingLineItemListProps {
  items: LexOfficeBookingDataLineItem[];
  isEditing: boolean;
  currency: string;
  onUpdate: (index: number, field: string, value: number | string) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  showValidation: boolean;
}

const BookingLineItemList: React.FC<BookingLineItemListProps> = ({
  items,
  isEditing,
  currency,
  onUpdate,
  onAdd,
  onRemove,
  showValidation,
}) => {
  return (
    <div className='space-y-2'>
      <div className='space-y-3'>
        {items.length === 0 ? (
          <div className='px-3 py-4 text-center text-sm text-gray-500 italic'>
            No line items
          </div>
        ) : (
          items.map((item, index) => (
            // index-as-key is safe here: all card state is controlled via props,
            // so re-keying on mid-list deletion produces correct renders.
            <BookingLineItemCard
              key={index}
              item={item}
              index={index}
              isEditing={isEditing}
              currency={currency}
              onUpdate={onUpdate}
              onRemove={onRemove}
              showValidation={showValidation}
            />
          ))
        )}
      </div>

      {/* Add Line Item button in edit mode */}
      {isEditing && (
        <div className='flex justify-end'>
          <button
            onClick={onAdd}
            className='text-sm text-blue-600 hover:text-blue-800 underline flex items-center gap-1'
          >
            <PlusIcon className='w-4 h-4' />
            Add line item
          </button>
        </div>
      )}
    </div>
  );
};

export default BookingLineItemList;
